import React, {useEffect, useState} from 'react'
import Navbar from '../components/Navbar'
import '../assets/css/dashboard.css'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { getUser } from '../utils/profile';

import { Greet } from '../components/DashboardComponent'

const Preferences = () => {
    const history = useHistory()
    if (!sessionStorage.getItem('idToken')) {
        history.push('/signin')
    }

    const [profile, setProfile] = useState(null)
    const [, setIsPending] = useState(false)
    const [, setError] = useState(null)
    
    useEffect(() => {
        document.title = 'Pouch | preferences'
        const fetchUser = async () => {
            setIsPending(true)
            let user = await getUser(sessionStorage.getItem('localId'))
            console.log(user)
            if (!user) {
              setError('Could not fetch user data')
            } else {
              if(user.code === 400) {
                setError(user.message || 'Could not fetch user data')
              } else {
                setProfile(user)
              }
            }
        }
        fetchUser()
        setIsPending(false)
        console.log(profile)
        // eslint-disable-next-line
    }, [])

    return (
        <>
            <Navbar />
            {profile ? <div className="container p-2">
                {/* Preferences hero */}
                <div className="py-3">
                    <div className="row mx-0">
                        <Greet />
                    </div>
                </div>

                <hr className="bg-purple" />

                {/* Prefences setting */}
                <div className="my-3 shadow-lg p-3">
                    <h6>Preferences Settings</h6>
                    <form action="#" method="post">
                        <div className="row">
                            <div className="col-md">
                                <div className="form-group">
                                    <label htmlFor="name">Name</label>
                                    <input type="text" id="name" placeholder="Name" className="form-control" />
                                </div>
                            </div>
                            <div className="col-md">
                                <div className="form-group">
                                    <label htmlFor="avatar">Avatar</label>
                                        <div className="input-group">
                                            <input type="file" name="avatar" className="form-control" />
                                            <div className="input-group-append">
                                                <div className="input-group-text">Upload</div>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-purple" >Update Preferences</button>
                    </form>
                </div>
            </div> :
                <p className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh'}}>                    
                    <FontAwesomeIcon icon={faSpinner} spin className="h3 display-4" />
                </p>
            }
        </>
    )
}

export default Preferences